module.exports = __webpack_public_path__ + "img/team-3.497bb359.jpg";